document.addEventListener('DOMContentLoaded', function() {

  // ── Filter group accordion (desktop sidebar) ──
  document.querySelectorAll('[data-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = this.closest('.filter-group');
      if (group) group.classList.toggle('is-open');
    });
  });

  // ── Facet menu ──
  // Built from the rendered rows rather than hardcoded, so every option maps to
  // real products, counts are real, and an option that would return nothing is
  // never offered. Within a facet the options OR together; across facets they AND.
  // One render fills both the desktop sidebar and the mobile bar.
  (function () {
    var host = document.querySelector('[data-facets]');
    var mBar = document.querySelector('[data-mobile-facets]');
    var mPills = document.querySelector('[data-mobile-pills]');
    var mPanel = document.querySelector('[data-mobile-panel]');
    var rows = Array.prototype.slice.call(document.querySelectorAll('.product-row'));
    if (!rows.length) return;

    var GROUPS = [
      { key: 'category', label: 'Category' },
      { key: 'medium',   label: 'Medium'   },
      { key: 'region',   label: 'Region'   },
      { key: 'period',   label: 'Period'   },
      { key: 'tribe',    label: 'Tribe'    },
      { key: 'artist',   label: 'Artist'   }
    ];
    // Display-only shortening. The full value still drives matching, so the
    // filter keeps working against custom.origin exactly as stored.
    var LABELS = { 'Democratic Republic of the Congo, Central Africa': 'Congo, Central Africa' };
    function labelFor(v) { return LABELS[v] || v; }
    // Mobile columns are narrow, so regions drop the ", West Africa" part.
    function shortLabelFor(v) { return labelFor(v).replace(/, [A-Za-z ]*Africa$/, ''); }
    function esc(v) {
      return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    var selected = {};
    GROUPS.forEach(function (g) { selected[g.key] = []; });
    var openState = {};      // desktop groups the visitor opened or closed
    var mobileOpen = null;   // group whose mobile panel is showing

    function valuesOf(row, key) {
      var raw = row.getAttribute('data-' + key) || '';
      if (!raw) return [];
      return raw.split('|').map(function (v) { return v.trim(); }).filter(Boolean);
    }
    function rowMatches(row, skipKey) {
      return GROUPS.every(function (g) {
        if (g.key === skipKey) return true;
        var chosen = selected[g.key];
        if (!chosen.length) return true;
        var vals = valuesOf(row, g.key);
        return chosen.some(function (c) { return vals.indexOf(c) !== -1; });
      });
    }
    // count for an option = what you would get if you added it, given the other facets
    function countFor(key, value) {
      return rows.filter(function (r) {
        return rowMatches(r, key) && valuesOf(r, key).indexOf(value) !== -1;
      }).length;
    }
    function optionsFor(key) {
      var seen = {};
      rows.forEach(function (r) { valuesOf(r, key).forEach(function (v) { seen[v] = true; }); });
      return Object.keys(seen).sort(function (a, b) { return a.localeCompare(b); });
    }
    function matchCount() { return rows.filter(function (r) { return rowMatches(r, null); }).length; }
    function optionHtml(g, o, label) {
      return '<button type="button" class="filter-option' + (o.on ? ' is-checked' : '') +
               '" data-facet="' + g.key + '" data-value="' + esc(o.value) + '">' +
               '<div class="filter-option__box"></div>' +
               '<span class="filter-option__label">' + esc(label) + '</span>' +
             '</button>';
    }

    function render() {
      var live = [];
      GROUPS.forEach(function (g, gi) {
        var opts = optionsFor(g.key).map(function (v) {
          return { value: v, count: countFor(g.key, v), on: selected[g.key].indexOf(v) !== -1 };
        }).filter(function (o) { return o.count > 0 || o.on; });   // never offer a dead end
        // A lone option every visible piece already has filters nothing
        // (Category: Stone Sculpture on the stone collection); leave it out.
        if (opts.length === 1 && !opts[0].on) {
          var pool = rows.filter(function (r) { return rowMatches(r, g.key); }).length;
          if (opts[0].count === pool) return;
        }
        if (opts.length) live.push({ g: g, gi: gi, opts: opts });
      });

      if (host) {
        host.innerHTML = live.map(function (l) {
          var k = l.g.key;
          var isOpen = k in openState ? openState[k] : (l.gi < 3 || selected[k].length > 0);
          return '<div class="filter-group' + (isOpen ? ' is-open' : '') + '" data-group="' + k + '">' +
                   '<button class="filter-group__trigger" data-trigger type="button">' +
                     '<span class="filter-group__label">' + l.g.label + '</span>' +
                     '<span class="filter-group__icon">+</span>' +
                   '</button>' +
                   '<div class="filter-group__body"><div class="filter-group__options">' +
                     l.opts.map(function (o) { return optionHtml(l.g, o, labelFor(o.value)); }).join('') +
                   '</div></div></div>';
        }).join('');
      }

      if (mBar && mPills && mPanel) {
        if (!live.some(function (l) { return l.g.key === mobileOpen; })) mobileOpen = null;
        mPills.innerHTML = live.map(function (l, i) {
          var k = l.g.key, n = selected[k].length, on = k === mobileOpen;
          // the last pill stretches over any empty cells in its row
          var rem = live.length % 3;
          var span = (i === live.length - 1 && rem) ? ' style="grid-column: span ' + (4 - rem) + '"' : '';
          return '<button type="button" class="mobile-filter-pill' + (on ? ' is-active' : '') + (n ? ' has-selection' : '') +
                   '" data-mgroup="' + k + '" aria-expanded="' + on + '"' + span + '>' +
                   l.g.label + (n ? ' <span class="mobile-filter-pill__n">' + n + '</span>' : '') +
                 '</button>';
        }).join('');
        var cur = live.filter(function (l) { return l.g.key === mobileOpen; })[0];
        if (cur) {
          var shown = matchCount();
          mPanel.innerHTML =
            '<div class="mobile-filter-panel__options">' +
              cur.opts.map(function (o) { return optionHtml(cur.g, o, shortLabelFor(o.value)); }).join('') +
            '</div>' +
            '<div class="mobile-filter-panel__foot">' +
              '<button type="button" class="mobile-filter-panel__clear" data-mclear' +
                (selected[cur.g.key].length ? '' : ' disabled') + '>Clear ' + cur.g.label + '</button>' +
              '<button type="button" class="mobile-filter-panel__done" data-mdone>Show ' + shown +
                (shown === 1 ? ' piece' : ' pieces') + '</button>' +
            '</div>';
          mPanel.hidden = false;
        } else {
          mPanel.innerHTML = '';
          mPanel.hidden = true;
        }
        mBar.classList.toggle('is-ready', live.length > 0);
      }
    }

    function apply() {
      var shown = 0;
      rows.forEach(function (r) {
        var ok = rowMatches(r, null);
        r.hidden = !ok;
        if (ok) shown++;
      });
      var clear = document.querySelector('.sidebar__clear');
      if (clear) {
        var any = GROUPS.some(function (g) { return selected[g.key].length; });
        clear.classList.toggle('sidebar__clear--disabled', !any);
      }
      var empty = document.querySelector('[data-empty-state]');
      if (empty) empty.hidden = shown !== 0;
    }

    // Selections live in the query string (?region=Kenya%2C+East+Africa&...), so
    // Back from a product, a reload, or a shared link keeps the filtered view.
    function syncUrl() {
      try {
        var params = new URLSearchParams(location.search);
        GROUPS.forEach(function (g) {
          params.delete(g.key);
          selected[g.key].forEach(function (v) { params.append(g.key, v); });
        });
        var qs = params.toString();
        history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
      } catch (e) {}
    }
    function readUrl() {
      try {
        var params = new URLSearchParams(location.search);
        GROUPS.forEach(function (g) {
          var known = optionsFor(g.key);
          selected[g.key] = params.getAll(g.key).filter(function (v) { return known.indexOf(v) !== -1; });
        });
      } catch (e) {}
    }
    // A change made deep in the list would otherwise leave you mid-results.
    function toListTop() {
      var main = document.querySelector('.shop-main');
      if (!main) return;
      var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 0;
      var y = main.getBoundingClientRect().top + window.pageYOffset - headerH;
      // instant: the page is scroll-behavior:smooth, and gliding up past
      // thousands of pixels of rows reads as the page jumping about
      if (window.pageYOffset > y + 1) window.scrollTo({ top: y, behavior: 'instant' });
    }
    function changed() { render(); apply(); syncUrl(); toListTop(); }

    function toggleValue(k, v) {
      var i = selected[k].indexOf(v);
      if (i === -1) selected[k].push(v); else selected[k].splice(i, 1);
      changed();
    }

    if (host) {
      host.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-facet]');
        if (opt) { toggleValue(opt.getAttribute('data-facet'), opt.getAttribute('data-value')); return; }
        var trig = e.target.closest('[data-trigger]');
        if (trig) {
          var grp = trig.closest('.filter-group');
          if (grp) openState[grp.getAttribute('data-group')] = grp.classList.toggle('is-open');
        }
      });
    }

    if (mBar) {
      mBar.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-facet]');
        if (opt) { toggleValue(opt.getAttribute('data-facet'), opt.getAttribute('data-value')); return; }
        var pill = e.target.closest('[data-mgroup]');
        if (pill) {
          var k = pill.getAttribute('data-mgroup');
          mobileOpen = mobileOpen === k ? null : k;
          render();
          return;
        }
        if (e.target.closest('[data-mclear]')) {
          selected[mobileOpen] = [];
          changed();
          return;
        }
        if (e.target.closest('[data-mdone]')) {
          mobileOpen = null;
          render();
          toListTop();
        }
      });
    }

    var clearBtn = document.querySelector('.sidebar__clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        GROUPS.forEach(function (g) { selected[g.key] = []; });
        changed();
      });
    }

    readUrl();
    render(); apply();
  })();

});
